import React from "react";
import ReactModal from "react-modal";

import s from "./Dialog.module.scss";

interface IAction {
	title: string;

	func(): void;
}

interface IDialogProps {
	title: string;
	isOpen: boolean;
	actions: IAction[];
	children: JSX.Element;
	testId?: string;
}

ReactModal.setAppElement("#root");

export const Dialog = ({ title, isOpen, actions, children, testId }: IDialogProps) => (
	<ReactModal
		isOpen={isOpen}
		className={s.dialog}
		testId={testId}
		overlayClassName={s.dialog_overlay}>
		<div className={s.dialogContent}>
			<div className={s.dialogContent__column}>
				<div className={[s.dialogContent__header, s.header].join(" ")}>
					<div className={s.header__row}>
						<div className={s.header__titleText}>{title}</div>
					</div>
				</div>
				<div className={[s.dialogContent__body, s.body].join(" ")}>
					{children}
				</div>
				<div className={[s.dialogContent__footer, s.footer].join(" ")}>
					<div className={s.footer__row}>
						{actions?.map(action => (
							<button key={action.title} className={s.footer__button} onClick={action.func}>{action.title}</button>
						))}
					</div>
				</div>
			</div>
		</div>
	</ReactModal>
);
